import axios from '../helpers/axios';
import { logError } from '../services';
import { HubspotFormField, IHubspotForm } from '../models';

const baseUrl = '/api/homeowner-portal/hubspot/form';

// Converts Formik values into FormData for HubSpot
function buildFormData(values: HubspotFormField[]): FormData {
  const formData = new FormData();

  values.forEach((element, index) => {
    Object.entries(element).forEach(([key, value]) => {
      //files are finicky
      // they need to be added to the form with the `name` field from the HubspotFormField
      // AND they need to have a form object built out so that it can be deserialized
      // on the backend the files are uploaded separately and then an identifier is added to the submitted form data
      if (Array.isArray(value) && value.length > 0 && value[0] instanceof File) {
        // Use the 'name' property from HubspotFormField for the file key
        const fieldName = element.name;
        value.forEach(file => {
          formData.append(fieldName, file);
        });
        // Add the array element as an empty string
        formData.append(`fields[${index}].${key}`, '');
      } else {
        formData.append(`fields[${index}].${key}`, value ?? '');
      }
    });
  });

  return formData;
}

export const getHubspotPhotoUploadForm = async (): Promise<IHubspotForm> => {
  try {
    const { data } = await axios.get(`${baseUrl}/photo-upload`);
    return data;
  } catch (error) {
    logError(error, 'getHubspotPhotoUploadForm failed');
    return Promise.reject(error);
  }
};

export const submitHubspotPhotoUploadForm = async (values: HubspotFormField[]): Promise<void> => {
  const formData = buildFormData(values);

  try {
    await axios.post(`${baseUrl}/photo-upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  } catch (error) {
    logError(error, 'submitHubspotPhotoUploadForm failed');
    return Promise.reject(error);
  }
};

export const getHubspotReferralForm = async (): Promise<IHubspotForm> => {
  try {
    const { data } = await axios.get(`${baseUrl}/referral`);
    return data;
  } catch (error) {
    logError(error, 'getHubspotReferralForm failed');
    return Promise.reject(error);
  }
};

export const submitHubspotReferralForm = async (values: HubspotFormField[]): Promise<void> => {
  const formData = buildFormData(values);

  try {
    await axios.post(`${baseUrl}/referral`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  } catch (error) {
    logError(error, 'submitHubspotReferralForm failed');
    return Promise.reject(error);
  }
};
